export { useAuth } from "@/lib/auth-context";
